import React,{useEffect} from 'react';
import { Col, Row } from "react-bootstrap";
import { Dispatch,bindActionCreators, AnyAction } from 'redux';
import { connect } from 'react-redux';
import { AppState } from '../../store/configureStore';
import { dcrActionCreators } from '../../store/DCRStore';
import { helperActionCreators } from '../../store/HelperStore';
import Skeleton from "react-loading-skeleton";
import { stateLoading } from '../../functions/stateLoading';
import { cmsActionCreators } from '../../store/CmsStore';

type TLogoutProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;
const Logout = (props: TLogoutProps) => {

    sessionStorage.removeItem("CM.ContextToken");
    sessionStorage.clear();

    useEffect(() => {
        if (stateLoading(props.helper)) {
            props.fetchAllConfiguration();
        }
    });  

    const cmsLogoutData = props.cmsData.fragments?.find((f: any) => f.name === "Logout");

    useEffect(() => {
        if (stateLoading(props.cmsData)) {
            props.fetchCmsData();
        }
    });

    return(
        <Row className="logout-container">
            <Col>
                <Row className="ml-1 mt-2 my-3">
                    <Col className="tbl-info-wrap float-left col-9">
                        <h4>Logout</h4>
                    </Col>
                </Row>

                <Row className="ml-3 mx-1 my-2">
                    <Col className="col-9 ml-3 mt-2">
                        {cmsLogoutData && props.helper.xspURLReponseInfo?.url
                            ? <>
                                <div dangerouslySetInnerHTML={{ __html: cmsLogoutData.html }} />
                                <p>Click <a href={props.helper.xspURLReponseInfo.url}>here</a> to open Wespath Portal.</p>
                            </>
                            : <LoadingSkeleton />
                        }
                    </Col>
                </Row>
            </Col>
        </Row>
    );

}

const LoadingSkeleton = () => (
    <>
        <p><Skeleton width="90%" /></p>
        <p><Skeleton width="90%" /></p>
        <p><Skeleton width="30%" /></p>
    </>
);

function mapStateToProps(state: AppState) {
    return {
        currentUser: state.dcr.currentuserInfo.user,
        helper: state.helper,
        cmsData: state.cms.logout
    }
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return bindActionCreators({ 
        ...dcrActionCreators,
        ...helperActionCreators,
        fetchCmsData: cmsActionCreators.fetchLogoutCmsData
    }, dispatch);
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Logout);